import { createMuiTheme } from "@material-ui/core/styles";

import "./theme.css";

const theme = createMuiTheme({
    palette: {
        primary: {
            main: "#26b7cd",
        },
    },

    typography: {
        fontFamily: "Chivo",
    },
});

export default theme;
